import { render, staticRenderFns } from "./Quotations.vue?vue&type=template&id=639e4209&scoped=true"
import script from "./Quotations.vue?vue&type=script&lang=js"
export * from "./Quotations.vue?vue&type=script&lang=js"
import style0 from "./Quotations.vue?vue&type=style&index=0&id=639e4209&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e4209",
  null
  
)

export default component.exports